import script from "./GiftCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftCard.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=f3205944&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3205944"]])

export default __exports__